import { h } from "omi";

import { NWIcon, NWProBadge, NWTooltip, openProModal } from "@/components";
import { Store } from "@/store";

export function EditAnswer(props: { onClick?: (e: MouseEvent) => void }) {
  return (
    <div
      class="w-fit cursor-pointer"
      onClick={!Store.user.isPro() ? () => openProModal("validation_edit") : props.onClick}
    >
      <NWTooltip placement="top" content="⭐ Coming soon!" shouldShow={!Store.features.hasFeature("projects.payments")}>
        <div class="flex items-center space-x-1">
          <div class="inline-flex select-none px-0 py-1 items-center space-x-1.5 text-sm font-semibold">
            <NWIcon name="edit" />
            <p>Edit answer</p>
          </div>
          <NWProBadge location="validation-inline" />
        </div>
      </NWTooltip>
    </div>
  );
}
